"use strict";
exports.__esModule = true;
exports.setResellerId = void 0;
var resellerservice_1 = require("../helpers/resellerservice");
var config_js_1 = require("../config.js");
var index_1 = require("./index");
var salesManService = new resellerservice_1["default"](config_js_1.serviceroot);
var setResellerId = function (resellerId) { return function (dispatch, getState) {
    salesManService.GetResellerAsync(resellerId).then(function (salesman) {
        if (salesman) {
            dispatch((0, index_1.clientCofigurationUpdated)(config_js_1.clientConfigurations[salesman.slideConfig]));
            dispatch({ type: 'SET_RESELLERID', resellerId: resellerId });
        }
        else {
            dispatch((0, index_1.displayError)(true, "Virheellinen j�lleenmyyj�tunnus. Tarkasta linkin oikeellisuus."));
        }
    });
}; };
exports.setResellerId = setResellerId;
